<template>
  <div v-if="items.length">
    <ui-card
      v-bind="$attrs"
      :is-loading="isLoading"
      class="h-100"
    >
      <div class="card-header pt-0 px-0">
        <h4 class="card-title">
          {{ $t('reviews.complaintsTitle') }}
        </h4>
      </div>
      <template v-if="previewReviews.length">
        <div
          v-for="item in previewReviews"
          :key="item.id"
          class="d-flex justify-content-between mt-4"
        >
          <div class="card-label">
            {{ $t(item.name) }}
          </div>
          <div class="card-value">
            {{ item.stats }}
          </div>
        </div>
      </template>
      <span v-else class="text-gray">
      {{ $t('noData') }}
    </span>

      <template #footer>
        <stats-complaints-modal
          v-if="statsReviews.length > previewCount"
          :reviews="statsReviews"
          :location-type="locationType"
        >
          <template #activator="{ open }">
            <ui-button
              link
              type="primary"
              @click="open"
            >
              {{ $t('form.buttons.viewAll') }}
            </ui-button>
          </template>
        </stats-complaints-modal>
      </template>
    </ui-card>
  </div>
</template>

<script>
import api from '@/api';
import StatsComplaintsModal from './StatsComplaintsModal.vue';
import StatsMixin from './StatsMixin';

export default {

  mixins: [
    StatsMixin,
  ],

  components: {
    StatsComplaintsModal,
  },

  props: {
    reviews: {
      type: Array,
      required: true,
    },
    locationType: {
      type: String,
      default: 'restaurant',
    },
    groupId: [Number, String],
  },

  data: () => ({
    items: [],
    previewCount: 3,
  }),

  watch: {
    items: {
      handler(value) {
        if (value.length) {
          this.$emit('visible');
        }
      },
    },
  },

  computed: {
    statsReviews() {
      const result = this.reviews
        .filter(({ workPlaceType }) => {
          return workPlaceType === this.locationType;
        })
        .map(({ id, ...params }) => {
          const stats = this.items.find((item) => String(item.id) === String(id));

          return {
            ...params,
            id,
            stats: parseInt(stats?.cnt || 0, 10),
          };
        })
        .filter(({ stats }) => {
          return stats > 0;
        });

      result.sort((a, b) => b.stats - a.stats);

      return result;
    },
    previewReviews() {
      return this.statsReviews.slice(0, this.previewCount);
    },
  },

  methods: {
    async load() {
      const { data } = await api.locations.getTopComplaints({
        locationId: this.locationId,
        groupId: this.groupId || undefined,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      });

      if (data) {
        this.items = data;
      }
    },
  },
};
</script>
